import type { Item } from "./api.js";

/**
 * What is *left* in a list — the one number every badge shows.
 *
 * The rule, written once: an item counts while `done` is false. "Non-deleted"
 * needs no clause, because the store never holds a deleted item — a tombstone
 * removes the row from the map, and so from `store.allItems()`. Total items
 * and due-today counts are deliberately not offered (L03).
 *
 * A fully checked list has no entry; the caller reads that as zero. An
 * explicit zero here would be a second way of saying the same thing.
 */
export function uncheckedByList(items: Iterable<Item>): Map<string, number> {
  const counts = new Map<string, number>();
  for (const item of items) {
    if (item.done) continue;
    counts.set(item.listId, (counts.get(item.listId) ?? 0) + 1);
  }
  return counts;
}

/**
 * "3 remaining": a list header's one summary (g52). The same number a badge
 * shows for that list, so the header and the rail can never disagree.
 */
export function remainingPhrase(count: number): string {
  return `${count} remaining`;
}

/** "8 unchecked items", for the accessible name a badge is part of. */
export function uncheckedPhrase(count: number): string {
  return `${count} unchecked ${count === 1 ? "item" : "items"}`;
}
